import { useContext } from "react";
import { View, XStack, YStack } from "tamagui";

import Salad from "@/assets/images/landing_page/salad.png";
import { Button, Image, Section, Square } from "@/components";
import { LayoutContext } from "@/components/LayoutProvider";
import { Link, Paragraph, Text } from "@/components/Typography";
import LandingGradientBackground from "@/landing-page/general-care/LandingGradientBackground";
export default function Glp1ReadyWhenYouAre({
  onPress,
  isPending,
}: {
  onPress: () => void;
  isPending: boolean;
}) {
  const { lg } = useContext(LayoutContext);

  const textContent = (
    <YStack flex={lg ? 1 : undefined} gap="$150" justifyContent="center">
      <Text size="$xxl">Ready when you are</Text>
      <Text size="$md" color="$textSecondary" marginBottom="$200">
        No insurance. No appointments. Just results.
      </Text>
      <Section alignItems="center" gap="$200">
        <Button onPress={onPress} disabled={isPending} alignSelf="stretch">
          See if you are eligible →
        </Button>
        <Paragraph textAlign="center" size="$xs" color="$textPrimary">
          By continuing, you agree to our{" "}
          <Link size="$xs" href="/terms" bold>
            Terms
          </Link>{" "}
          and{" "}
          <Link size="$xs" href="/privacy" bold>
            Privacy Policy
          </Link>
          .
        </Paragraph>
      </Section>
    </YStack>
  );

  const image = (
    <View flex={lg ? 1 : undefined} alignItems="center" justifyContent="center">
      <Square
        size={350}
        $xl={{ size: 400 }}
        borderRadius="$300"
        overflow="hidden"
        shadowRadius="$400"
        shadowOpacity={0.3}
        shadowColor="$shadowPartnerHero"
        shadowOffset={{ width: 0, height: 4 }}
      >
        <Image width="100%" height="100%" objectFit="cover" source={Salad} />
      </Square>
    </View>
  );

  return (
    <LandingGradientBackground>
      <YStack
        maxWidth="$landingPageConstraint"
        alignSelf="center"
        paddingHorizontal="$400"
        paddingVertical={lg ? "$800" : "$400"}
        gap="$800"
        width="100%"
      >
        {lg ? (
          <XStack gap="$800" alignItems="center" width="100%">
            {image}
            {textContent}
          </XStack>
        ) : (
          <YStack gap="$400">
            {textContent}
            {image}
          </YStack>
        )}
      </YStack>
    </LandingGradientBackground>
  );
}
